import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app-core/services/common.service';
import { CommonDataModel } from 'src/app/shared/common-data-model';
import { OrdersShippingUnitListComponent } from '../orders-shipping-unit-list/orders-shipping-unit-list.component';

@Component({
  selector: 'app-orders-action-common-form',
  templateUrl: './orders-action-common-form.component.html',
  styleUrls: ['./orders-action-common-form.component.scss']
})
export class OrdersActionCommonFormComponent implements OnInit {

  @ViewChild('OrdersShippingUnitListComponent', { static: false }) OrdersShippingUnitListComponent: OrdersShippingUnitListComponent;
  ordersDataModel = new CommonDataModel();
  orderActionStatusUpdateModel: any;
  isFormLoading = false;
  statusList: Array<any>;
  actionData: any;
  isJob: any;

  constructor(
    public dialog: MatDialog,
    private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<OrdersActionCommonFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.isJob = (this.router.url.indexOf('/quotes-list') !== -1) ? false : true;
    this.actionData = data;
    if(this.actionData.type === 'buildComplete'){
      this.orderActionStatusUpdateModel = this.ordersDataModel.ordersBuildCompleteModelData;
    } else if(this.actionData.type === 'hold'){
      this.orderActionStatusUpdateModel = this.ordersDataModel.ordersHoldModelData;
    }
   }

  ngOnInit() {
    this.getOrderStatus();
  }

  getOrderStatus() {
    this.commonService.getOrderStatus(`IsJob=${this.isJob}`).subscribe((response: any) => {
      this.statusList = response.data;
    });
  }

  onSubmit() {
    this.orderActionStatusUpdateModel.orderId = this.actionData.dataItem.jobId;
    this.orderActionStatusUpdateModel;
    // this will change once API is ready
    // this.commonService.orderBulkUpdate(this.orderActionStatusUpdateModel).subscribe((response: any) => {
    //   if(response.isSuccess){
    //     this.toastr.success(response.errors || 'Updated successfully');
    //     this.dialogRef.close(true);
    //   }else{
    //     this.toastr.error(response.errors || 'Something went wrong please Re-try', 'Error!');
    //   }
    // });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

}
